import styles from './index.module.scss';
import { defineComponent, h } from 'vue';
import { LOG, display_message_to_user } from '@phi/logging/frontend';
import { ClickableElement } from '@phi/touch';
import { PhiLogo } from '@components/icons';
import { rem } from '@phi/util/css';

export default defineComponent({
    props: {
        immersive: {
            required: true,
            type: Boolean,
        },

        light: {
            required: false,
            type: Boolean,
            default: true,
        },
    },

    emits: {
        'update:immersive': (x: boolean) => true,
    },

    data() {
        return {
            pressed_once: false,
        };
    },

    watch: {
        immersive(value: typeof this.immersive) {
            if (value)
                this.pressed_once = true;
        },

        pressed_once(value: typeof this.pressed_once, old: typeof this.pressed_once) {
            if (value && !old) {
                display_message_to_user(LOG.INFO, 'You are in immersive mode. You can go back to the regular layout by pressing the Phi logo again.');
            }
        }
    },

    methods: {
        toggle_full_screen() {
            if (document.fullscreenElement) {
                if ('exitFullscreen' in document)
                    document.exitFullscreen();
                else if ('webkitExitFullscreen' in document)
                    // @ts-ignore
                    document.webkitExitFullscreen();
            } else {
                if ('requestFullscreen' in document.documentElement)
                    document.documentElement.requestFullscreen();
                else if ('webkitRequestFullscreen' in document.documentElement)
                    // @ts-ignore
                    document.documentElement.webkitRequestFullscreen();
            }
        },

        toggle_immersive() {
            this.$emit('update:immersive', !this.immersive);
        },
    },

    render() {
        return h(ClickableElement, {
            class: styles.logo,
            onClick: this.toggle_immersive,
            onLongClick: this.toggle_full_screen,
        }, () => PhiLogo(this.light, rem(2.5)));
    }
});
